import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Menu from "@/components/Menu";
import Location from "@/components/Location";
import About from "@/components/About";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-brand-bg min-h-screen">
      <Header />
      <main>
        <Hero />
        <Menu />
        <Location />
        <About />
      </main>
      <Footer />
    </div>
  );
}
